import { useEffect, useState } from 'react';
import { bool, object } from 'prop-types';
import { debounce, get } from 'lodash';
import usePartner from './hooks/usePartner';
import * as paths from '../../config/paths';
import { Link, useNavigate } from 'react-router-dom';
import { createRoute, getQueryParamByName } from '../../lib/router';

import styled from 'styled-components';
import { colors, Select } from '@podiumhq/podium-ui';
import { Icon } from '@podiumhq/design-system';
import { useTracking } from '@podiumhq/tracking';

const typeOptions = [
  { value: 'Organizations', label: 'Organizations' },
  { value: 'Locations', label: 'Locations' },
  { value: 'Users', label: 'Users' },
  { value: 'Partners', label: 'Partners' },
];

const TabLogoAndSearch = props => {
  const { skyhookCanViewPartner, currentUser, location, isLocationHome } =
    props;

  const navigate = useNavigate();
  const { trackEvent } = useTracking();

  const [searchType, setSearchType] = useState('Organizations');
  const [search, setSearch] = useState(
    getQueryParamByName(location.search, 'query')
  );

  const { isPartner } = usePartner();
  const partnerUid = get(currentUser, 'partnerUid', 0);

  useEffect(() => {
    setSearch(getQueryParamByName(location.search, 'query'));
  }, [location]);

  useEffect(() => {
    const searchFilter = getQueryParamByName(location.search, 'searchType');
    if (searchFilter) setSearchType(searchFilter);
  }, [location.search]);

  function onKeyPress(event) {
    if (event.key !== 'Enter') return;
    onChangeSearch(search);
  }

  function onChange(event) {
    const { value } = event.target;
    setSearch(value);
  }

  const onChangeSearch = debounce(query => {
    trackEvent('admin.searchButton.clicked', { searchType });
    navigate({
      pathname: paths.SEARCH,
      search: new URLSearchParams({ query, searchType }).toString(),
    });
  }, 300);

  return (
    <Wrapper>
      <Link
        to={
          skyhookCanViewPartner
            ? createRoute(paths.PARTNER_ORGANIZATIONS, { partnerUid })
            : createRoute(paths.HOME)
        }
      >
        <Logo type="Logo" boxSize={9} color="silver.lightest" />
      </Link>
      {!isLocationHome && !isPartner && (
        <SearchSelection>
          <div>
            <Search
              theme="dark"
              type="text"
              placeholder="Search"
              value={search}
              onChange={onChange}
              onKeyPress={onKeyPress}
            />
            <>
              <Select
                id="search-filter"
                style={{
                  container: {
                    color: `${colors.mineShaft}`,
                    marginLeft: '-190px',
                    marginRight: '50px',
                    paddingRight: '5px',
                    width: '150px',
                    borderLeft: `solid 1px ${colors.mineShaft}`,
                    zIndex: '2',
                  },
                  trigger: {
                    background: `${colors.black}`,
                    color: `${colors.white}`,
                    cursor: 'pointer',
                    wordWrap: 'initial',
                  },
                }}
                border={'none'}
                value={searchType}
                onChange={e => setSearchType(e.target.value)}
              >
                {typeOptions.map(type => (
                  <Select.Option key={type.value} value={type.value}>
                    {type.label}
                  </Select.Option>
                ))}
              </Select>
            </>
          </div>
        </SearchSelection>
      )}
    </Wrapper>
  );
};

TabLogoAndSearch.propTypes = {
  skyhookCanViewPartner: bool.isRequired,
  currentUser: object.isRequired,
  location: object.isRequired,
  isLocationHome: bool.isRequired,
};

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
`;

const Logo = styled(Icon)`
  margin-right: 10px;
`;

const Search = styled.input`
  width: 512px;
  height: 45px;
  border-radius: 36px;
  padding: 0 30px;
  margin-top: 4px;
  font-weight: 500;
  font-size: 16px;
  margin-right: 30px;
  background: ${colors.black};
  color: ${colors.white};
  :focus-visible {
    outline: none;
  }
`;

const SearchSelection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export default TabLogoAndSearch;
